/*
 * @Author: huangzq
 * @Date: 2020-04-16 20:21:36
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-16 20:21:36
 * @Desc: 分享弹窗组件-已手动保持一致
*/
<template>
  <div class="share-dialog">
    <mk-dialog
      :visible="visible"
      width="520px"
      hide-header
      @close="onClose"
      @closed="tabName='qrcode'"
    >
      <div class="content-wrapper">
        <mk-tabs-biz
          v-model="tabName"
          class="el-tabs-mk-ui-mini"
        >
          <mk-tab-pane
            label="扫码分享"
            name="qrcode"
          >
            <div class="qrcode-wrapper">
              <span>扫码分享：</span>
              <img
                :src="dialogData.qrcodeUrl"
                class="qrcode-url"
                alt="qrcodeUrl"
              >
            </div>
          </mk-tab-pane>
          <mk-tab-pane
            label="链接分享"
            name="link"
          >
            <div class="link-wrapper">
              <span>链接分享：</span>
              <p class="link-url">
                {{ dialogData.linkUrl }}
              </p>
            </div>
          </mk-tab-pane>
        </mk-tabs-biz>
        <mk-iconfont
          icon-class="guanbi"
          class="close-icon cursor"
          @click.native="onClose"
        />
      </div>
      <div
        slot="footer"
        class="footer-wrapper"
      >
        <span
          class="cancel cursor"
          @click="onClose"
        >
          取消
        </span>
        <mk-button-biz
          v-if="tabName==='link'"
          :data-clipboard-text="dialogData.linkUrl"
          width="80px"
          font-size="13px"
          type="primary"
          class="copy-btn"
          @click="copyLinkFun"
        >
          复制链接
        </mk-button-biz>
        <mk-button-biz
          v-else
          width="80px"
          font-size="13px"
          type="primary"
          @click="downloadQrcodeFun"
        >
          下载二维码
        </mk-button-biz>
      </div>
    </mk-dialog>
  </div>
</template>

<script>
export default {
  name: 'ShareDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default () {
        return {
          title: '',
          qrcodeUrl: '',
          linkUrl: ''
        }
      }
    }
  },
  data () {
    return {
      tabName: 'qrcode'
    }
  },
  methods: {
    /**
     * * 分享弹窗关闭事件
     */
    onClose () {
      this.$emit('update:visible', false)
    },

    /**
     * * 复制链接方法
     */
    copyLinkFun () {
      this.$clipboard('.copy-btn')
    },

    /**
     * * 下载二维码方法
     */

    downloadQrcodeFun () {
      this.util.download({
        title: this.dialogData.title + '-链接二维码',
        href: this.dialogData.qrcodeUrl
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.share-dialog {
  & /deep/ .el-dialog__body {
    padding: 0;
  }

  .cancel {
    margin-right: 30px;
    font-size: 13px;
    color: #8c8c8c;
  }

  .content-wrapper {
    position: relative;

    & /deep/ .mk-tabs-biz {
      .el-tabs__item {
        height: 54px;
        line-height: 54px;
      }

      .el-tabs__content {
        margin: 30px 20px 12px;
        background-color: #f5f7fd;
      }
    }

    .link-wrapper,
    .qrcode-wrapper {
      display: flex;
      align-items: center;
      padding: 20px;

      & > span {
        color: #8c8c8c;
      }
    }

    .qrcode-url {
      width: 142px;
      margin-left: 28px;
    }

    .link-url {
      flex: 1;
      color: #595959;
      line-height: 18px;
    }

    .close-icon {
      position: absolute;
      top: 0;
      right: 0;
      padding: 20px;
      font-size: 14px;
    }
  }
}
</style>
